import React from "react";
import "./loading.css";
const Loading = () => {
  return (
    <div className="loadingWrapper">
      <div class="loading">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default Loading;
